module.exports = __webpack_public_path__ + "static/location-info6-e80db34b1958ec1e11205bad9b01ffe4.jpg";